import styled from 'styled-components';

export const UserStatusCongratulationsBenefitsCardStyled = styled.div`
    position: relative;
    font-size: 14px;
    background: var(--color-background-secondary);
    box-shadow: var(--shadow-primary);
    padding: 28px 12px 12px;
    border-radius: var(--border-radius);
    min-height: 80px;
    display: flex;
    flex-direction: column;
    align-items: start;
    
    .unlimited-amount {
        font-size: 20px;
    }
`;

export const UserStatusCongratulationsBenefitsCardBadgeStyled = styled.div`
    padding: 0 14px;
    height: 100%;
    border-radius: 16px;
    background: var(--color-background-quaternary-to-secondary);
    box-shadow: var(--shadow-primary);
    display: flex;
    align-items: center;
    white-space: nowrap;
`;

export const UserStatusCongratulationsBenefitsCardBadgeIconStyled = styled(UserStatusCongratulationsBenefitsCardBadgeStyled)`
    padding: 0 4px;
`;

export const UserStatusCongratulationsBenefitsCardBadgePictureStyled = styled(UserStatusCongratulationsBenefitsCardBadgeStyled)`
    padding: 0;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    overflow: hidden;
    
    > * {
        width: 100%;
        height: 100%;
    }
`

export const UserStatusCongratulationsBenefitsCardBadgeContainerOuterStyled = styled.div`
    position: relative;
    height: 0;
    margin: 0 -4px;
`;

export const UserStatusCongratulationsBenefitsCardBadgeContainerInnerStyled = styled.div`
    position: relative;
    top: -44px;
    height: 32px;
`;
